import React, { useEffect } from 'react';
import moment from 'moment';
import { useCurrentMatches, useMatchesToday } from '../hooks/matches';
import TopMatch from '../components/CurrentMatches/TopMatch';
import { getCurrentMatchesPrefixed } from '../utils/matches';
import MatchRow from '../components/CurrentMatches/MatchRow';

function CurrentMatches({ showOnMatchDay }) {
  const [matches, currentMatchesLoading] = useCurrentMatches();
  const [matchesToday, matchesTodayLoading] = useMatchesToday();
  const [currentMatches, setCurrentMatches] = React.useState(null);
  const [highlightedMatch, setHighlightedMatch] = React.useState(null);

  useEffect(() => {
    if (!currentMatches && matches && matches.length > 0) {
      const currMatches = getCurrentMatchesPrefixed(matches);
      setCurrentMatches(currMatches);
      if (!highlightedMatch) {
        setHighlightedMatch(matches[0]);
      }
    }
  }, [matches, currentMatches, highlightedMatch]);

  if (currentMatchesLoading || matchesTodayLoading) {
    return null;
  }

  if (showOnMatchDay && !matchesToday?.length) {
    return null;
  }

  if (!showOnMatchDay && matchesToday?.length) {
    return null;
  }

  const markMatchAsHighlighted = (id) => {
    const match = currentMatches.find((m) => m.id === id);
    setHighlightedMatch(match);
  };

  const renderItem = (item) => {
    if (item?.isHeader) {
      const isToday = moment(item.sortId).isSame(moment(), 'day');
      const title = !isToday
        ? moment(item.sortId).format('dddd')
        : `Idag ${moment(item.sortId).format('HH:mm')}`;

      return (
        <div
          key={item.id}
          className="col-12 px-2 px-sm-4 pt-2 pt-sm-3 data-container__row"
        >
          <p
            className={
              isToday ? 'badge badge--comp-pink' : 'badge badge--comp-blue-3'
            }
          >
            {title}
          </p>
        </div>
      );
    }

    return (
      <MatchRow
        key={item.id}
        match={item}
        markMatchAsHighlighted={markMatchAsHighlighted}
        highlight={item?.id === highlightedMatch.id}
      />
    );
  };

  return (
    <section className="row mb-5">
      <div className="col-12 d-flex mb-3 mb-sm-4">
        <h2 className="heading-h6 heading-sm-h3 text-shadow">
          Aktuella matcher
        </h2>
      </div>
      {highlightedMatch && <TopMatch match={highlightedMatch} />}
      <div className="col-12 col-lg-6 d-flex justify-content-center flex-column ps-lg-0">
        <div className="data-container data-container--gradient">
          {currentMatches?.length > 0 &&
            currentMatches?.map((item) => renderItem(item))}
        </div>
      </div>
    </section>
  );
}

export default CurrentMatches;
